<template>
    <el-col :xs="{span:24}" :md="width" v-show="show">
        <el-form-item
            class="imageUpload"
            :class="className"
            :label="displayName" 
            :prop="name"
            :rules="rules">
            <input :name="fieldName" :value="valueString" hidden="hidden">
            <el-upload 
                class="width100"
                :class="disabledClass"
                :action="action"
                :data = "uploadData"
                :disabled= "disabled"
                :on-success="onSuccess"
                :on-error="onError"
                :before-remove="beforeRemove"
                :on-preview="onPreview"
                :multiple="isMultiple"
                accept="image/*"
                name="files"
                :file-list="data[name] || []">
                <el-button type="primary" size="default" :disabled="disabled" v-if="!isOnlyPhoto">点击上传</el-button>
                <el-button type="success" size="default" :disabled="disabled" @click.stop="dialogVisible = true" v-if="supportCamera"><el-icon><camera /></el-icon> 拍照</el-button>
                
                <template #tip>
                    <div class="el-upload__tip">
                        当前上传{{ (data[name]||[]).length }}张图片 
                    </div>
                    <div class="el-upload__tip">
                        {{ hint }}
                    </div>
                </template>
            </el-upload>
            <draggable 
                :list="data[name] || []" 
                class="el-upload-list el-upload-list--picture-card qweDraggableImg"
                ghost-class="ghost"
                itemKey="Url"
                :disabled="disabled">
                <template #item="{element , index}">
                    <div class="el-upload-list__item is-ready">
                        <el-image class="el-upload-list__item-thumbnail" :src="handleImg(element.url)" alt="">
                        </el-image>
                        <span class="el-upload-list__item-actions">
                            <span class="el-upload-list__item-preview"
                                @click="preView(element, index)">
                                <el-icon><zoom-in /></el-icon>
                            </span>
                            <span
                                v-if="!disabled"
                                class="el-upload-list__item-delete" >
                                <a class="image-a" :href="element.Url" :download="element.Name">
                                    <el-icon><download /></el-icon>
                                </a>
                            </span>
                            
                            <span
                                v-if="!disabled"
                                class="el-upload-list__item-delete"
                                @click="deleteMedia(element, index)">
                                <el-icon><delete /></el-icon>
                            </span>
                        </span>
                    </div>
                </template>
            </draggable>
        </el-form-item>
        
        <el-image-viewer
            @close="preViewState = false"
            hide-on-click-modal
            v-if="preViewState"
            :urlList="urlList" :initialIndex="index">
        </el-image-viewer>

        <el-dialog 
            v-model="dialogVisible"
            title="拍摄照片"
            @opened = "startupVideo"
            @closed = "endVideo">
            <video :id="videoDOM" :width="viewWidth" :height="viewHeight"></video>
            <video :id="saveVideoDOM" style="display: none;" :width="saveWidth" :height="saveHeight"></video>
            <canvas :id="saveCanvasDOM" style="display: none;" :width="saveWidth" :height="saveHeight"></canvas>
            <template #footer>
                <span class="dialog-footer">
                    <el-button @click="dialogVisible = false">取消</el-button>
                    <el-button type="success" @click="takePhoto">拍照</el-button>
                </span>
            </template>
        </el-dialog>

    </el-col>
</template>

<style>
    .imageUpload ul.el-upload-list.el-upload-list--text{
        display: none;
    }

    .qweDraggableImg div.el-upload-list__item{
        border: 0px;
        height: 100px;
        width: 100px;
    }
    .width100{
        width:100%
    }
    .image-a{
        color: white;
    }
</style>

<script>
    var mediaStreamTrack;
    var savemediaStreamTrack;
    import baseAttachFileField from "../AttachFileField/BaseAttachFileField" 
    import { Camera, ZoomIn, Download, Delete } from '@element-plus/icons-vue'
    import { ElMessage } from "element-plus";
    import { uploadFile,removeMedia } from "../../../apis/httpHelper"
    import draggable from 'vuedraggable'
    import { qweGuid, qweLetterGuid } from "../../../common/commonHelper";

    export default{
        name:"ImageField",
        mixins:[baseAttachFileField],
        data:function(){
            return {
                dialogVisible:false,
                supportCamera:false,
                isOnlyPhoto:false,
                index:1,
                preViewState:false,
                videoId:"abcds",
                saveWidth: 1280,
                saveHeight: 720,
                viewWidth: 400,
                viewHeight: 300,
            }
        },
        components:{
            'camera' : Camera,
            'draggable':draggable,
            'zoom-in':ZoomIn,
            'download':Download,
            'delete':Delete
        },
        created:function(){
            this.videoId = qweLetterGuid();
            this.isOnlyPhoto = this.selfSetting.IsOnlyPhoto;
            this.supportCamera = this.$store.state.supportCamera;

            this.viewWidth = this.selfSetting.Width === 0 ? 1280 : this.selfSetting.Width;
            this.viewHeight = this.selfSetting.Height === 0 ? 720 : this.selfSetting.Height;

            this.saveWidth = this.selfSetting.SaveWidth === 0 ? 1280 : this.selfSetting.SaveWidth;
            this.saveHeight = this.selfSetting.Height === 0 ? 720 : this.selfSetting.SaveHeight;
        },

        computed:{
            urlList:function(){
                return this.data[this.name].map(x=>x.Url);
            },

            videoDOM:function(){
                return this.videoId + "Video"
            },

            saveVideoDOM:function(){
                return this.videoId + "saveVideo"
            },

            saveCanvasDOM:function(){
                return this.videoId + "saveCanvas"
            }
        },
        
        methods:{
            deleteMedia:function(file){
                let that = this;
                if(this.disabled){
                    return;
                }
                this.$confirm("确认删除当前图片？", "删除图片", {
                    confirmButtonText: '删除',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(()=>{
                    if(file.IsNew){
                        return removeMedia(file.url).then(x=>{
                            if(x.Result == true){
                                let deleteIndex = that.data[that.name].findIndex(x=>x.uuid == file.uuid);
                                that.data[that.name].splice(deleteIndex, 1);
                            }
                        });
                    }
                    else{
                        let deleteIndex = that.data[that.name].findIndex(x=>x.url == file.url);
                        that.data[that.name].splice(deleteIndex, 1);
                    }
                }).catch(()=>{});
            }, 

            handleImg:function(url){
                return url + "?width=240&height=240" 
            },

            preView:function(file,index){
                this.index = index;
                this.preViewState = true;
            },

            handleDownload:function(file,index){
                
            },

            startupVideo:function(){
                let that = this;

                let showVideo = document.querySelector('#' + this.videoDOM);
                let saveVideo = document.querySelector('#' + this.saveVideoDOM);

                let saveVideoOptions = {
                    width: this.selfSetting.SaveWidth,
                    height: this.selfSetting.SaveHeight
                };

                navigator.mediaDevices.getUserMedia({
                    audio: false, 
                    video: saveVideoOptions
                }).then(showStream => {
                    showVideo.srcObject = showStream;
                    mediaStreamTrack = showStream;
                    showVideo.play(); //  播放视频
                }).catch(function(err) { 
                    console.log(that.displayName + "-" +that.name + "异常");
                    ElMessage.error("系统故障，摄像头不可用。",err);  
                    console.log(err);
                });

                navigator.mediaDevices.getUserMedia({
                    audio: false, 
                    video: saveVideoOptions
                }).then(saveStream => {
                    saveVideo.srcObject = saveStream;
                    savemediaStreamTrack = saveStream;
                    saveVideo.play(); //  播放视频
                }).catch(function(err) { 
                    console.log(that.displayName + "-" +that.name + "异常");
                    ElMessage.error("系统故障，摄像头不可用。",err);  
                    console.log(err);
                });
            },

            endVideo:function(){
                mediaStreamTrack.getTracks()[0].stop();
                savemediaStreamTrack.getTracks()[0].stop();
            },

            takePhoto:function(){
                let saveVideo = document.querySelector('#' + this.saveVideoDOM);
                let saveCanvas = document.querySelector('#' + this.saveCanvasDOM);

                let Context = saveCanvas.getContext('2d');
                Context.drawImage(saveVideo, 0, 0, this.selfSetting.SaveWidth, this.selfSetting.SaveHeight);

                let that = this;

                saveCanvas.toBlob(function (blob) {
                    uploadFile(that.contentType,that.name, blob, new Date().getTime() + ".jpeg")
                      .then(x=>{
                        ElMessage.success("成功")
                        let responseFile = x.Result[0];
                        that.data[that.name] = that.data[that.name] || [];
                        that.data[that.name].push({
                            IsNew: true,
                            uuid: qweGuid(),
                            url:responseFile.url,
                            name: responseFile.name,
                            Name: responseFile.name,
                            Url: responseFile.url
                        })
                    }).catch(x=>{
                        console.log(that.displayName + "-" +that.name + "上传异常");
                        console.log(x);
                    })
                }, 'image/jpeg', 0.90);

                this.dialogVisible = false;
            }
        }
    } 
</script>